import Checkbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import TextField from "@mui/material/TextField"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import type { ProductPostTestNoteFormValues } from "../../schemas"

import { TEXT_AREA_STYLING_PROPS } from "@/constants/forms"

export const ProductPostTestNoteForm: FC = () => {
  const { control } = useFormContext<ProductPostTestNoteFormValues>()

  return (
    <>
      <Controller
        name='printPostTestNotesToAkrochemCoa'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                data-testid='print-prost-test-notes-checkbox'
              />
            }
            label='Print Post Test Notes to Akrochem COA'
          />
        )}
      />
      <Controller
        name='postTestNotes'
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            {...TEXT_AREA_STYLING_PROPS}
            id='post-test-notes-input'
            data-testid='post-test-notes-input'
            placeholder='Add post-test note...'
            minRows={3}
            className='mt-6'
          />
        )}
      />
    </>
  )
}
